import { render, staticRenderFns } from "./LocationReport.vue?vue&type=template&id=a338ffa8&"
import script from "./LocationReport.vue?vue&type=script&lang=ts&"
export * from "./LocationReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage})
